import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { cn } from 'helpers/css';
import { isFunction, isPlainObject } from 'lodash';
import { Formik, Form } from 'formik';
import { isDefine } from 'helpers';
import useResponsive from 'hooks/useResponsive';
import NewDesign from '..';

/**
 *
 * @param {Object} props
 * @param {boolean} props.isOpen
 * @param {() => void} props.toggle
 * @param {string} props.className
 * @param {"from-right" | "from-left"} props.mode
 * @param {"JSX" | "string" | "number"} props.header
 * @param {"JSX" | "string" | "number" | ({ toggle, ...formikHelpers }) => JSX} props.content
 * @param {"JSX" | "string" | "number" | ({ toggle, ...formikHelpers }) => JSX} props.footer
 * @param {{
 *  initialValues: Object,
 *  onSubmit: (values: Object, formikHelpers: Object) => void,
 *  validationSchema: any,
 *  validateOnChange: boolean,
 *  validateOnBlur: boolean
 * }} props.form
 * @param {any} props.innerRef
 * @returns
 */
const Dialog = (props) => {
  const {
    isOpen,
    toggle,
    className,
    header,
    content,
    footer,
    form,
    mode,
    innerRef,
    dataTour = 'dialog',
  } = props;
  const isForm = isPlainObject(form);
  const { isMobile } = useResponsive();

  if (isForm) {
    return (
      <Formik
        innerRef={innerRef}
        enableReinitialize
        validationSchema={form.validationSchema}
        validateOnBlur={form.validateOnBlur || false}
        validateOnChange={form.validateOnChange || false}
        initialValues={form.initialValues}
        onSubmit={(values, formikHelpers) => form.onSubmit(values, { ...formikHelpers, toggle })}
      >
        {(propsFormik) => {
          const propsForOutside = { ...propsFormik, toggle };

          return (
            <Modal
              dataTour={dataTour}
              isOpen={isOpen}
              toggle={toggle}
              className={cn(className)}
              modalClassName={cn(
                isMobile && isDefine(mode) && 'mobile-dialog',
                isDefine(mode) && mode,
              )}
              backdrop={propsFormik.isSubmitting ? 'static' : true}
            >
              <Form>
                {header && <ModalHeader toggle={toggle}>{header}</ModalHeader>}

                <ModalBody className='tw-flex tw-flex-col tw-gap-2'>
                  {isFunction(content) ? content(propsForOutside) : content}
                </ModalBody>

                {footer && (
                  <ModalFooter>{isFunction(footer) ? footer(propsForOutside) : footer}</ModalFooter>
                )}
              </Form>
            </Modal>
          );
        }}
      </Formik>
    );
  }

  return (
    <Modal
      dataTour={dataTour}
      isOpen={isOpen}
      toggle={toggle}
      className={cn(className)}
      modalClassName={cn(isMobile && isDefine(mode) && 'mobile-dialog', isDefine(mode) && mode)}
    >
      {header && <ModalHeader toggle={toggle}>{header}</ModalHeader>}

      <ModalBody>{content}</ModalBody>

      {footer ? (
        <ModalFooter>{footer}</ModalFooter>
      ) : (
        <ModalFooter>
          <NewDesign.Button dataTour={`${dataTour}-close-button`} variant='ghost' onClick={toggle}>
            Close
          </NewDesign.Button>
        </ModalFooter>
      )}
    </Modal>
  );
};

export default Dialog;
